// pages/purchase-entry/DuplicateStep.tsx

import { AlertOctagon, FileX, ArrowLeft, CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useInvoiceEntryStore } from '@/stores/invoiceEntryStore';
import { getInvoiceLabels } from '@/lib/invoice-utils';

export function DuplicateStep() {
  const { duplicateDetails, transactionType, reset, setCurrentStep } = useInvoiceEntryStore();

  // Get dynamic labels
  const labels = getInvoiceLabels(transactionType);

  const handleUploadNew = () => {
    reset();
  };

  const handleGoBack = () => {
    setCurrentStep('upload');
  };

  return (
    <div className="space-y-8 py-8">
      {/* Main Alert */}
      <div className="flex flex-col items-center space-y-6">
        <div className="w-20 h-20 rounded-full bg-red-100 flex items-center justify-center">
          <FileX className="h-10 w-10 text-red-600" />
        </div>

        <div className="text-center space-y-3 max-w-md">
          <h2 className="text-xl font-semibold text-red-800">
            Duplicate Invoice Detected
          </h2>
          <p className="text-muted-foreground">
            This invoice is already present in your Tally. No need to process further.
          </p>
        </div>
      </div>

      {/* Invoice Details Card */}
      <div className="max-w-md mx-auto bg-red-50 border border-red-200 rounded-lg p-6 space-y-4">
        <div className="flex items-start gap-3">
          <AlertOctagon className="h-5 w-5 text-red-600 mt-0.5 flex-shrink-0" />
          <div className="space-y-3 flex-1">
            {duplicateDetails?.invoice_number && (
              <div>
                <span className="text-sm text-red-700 font-medium">{labels.invoice} #</span>
                <p className="text-red-900 font-semibold">{duplicateDetails.invoice_number}</p>
              </div>
            )}
            {duplicateDetails?.vendor && (
              <div>
                <span className="text-sm text-red-700 font-medium">{labels.party}</span>
                <p className="text-red-900">{duplicateDetails.vendor}</p>
              </div>
            )}
            {duplicateDetails?.date && (
              <div>
                <span className="text-sm text-red-700 font-medium">Dated</span>
                <p className="text-red-900">{duplicateDetails.date}</p>
              </div>
            )}
            {duplicateDetails?.reference && (
              <div>
                <span className="text-sm text-red-700 font-medium">Existing Reference</span>
                <p className="text-red-900">{duplicateDetails.reference}</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Status */}
      <div className="flex items-center justify-center gap-2 text-green-700">
        <CheckCircle2 className="h-5 w-5" />
        <span className="text-sm">Already recorded in Tally - no action needed</span>
      </div>

      {/* Actions */}
      <div className="flex justify-center gap-4 pt-4">
        <Button
          variant="outline"
          onClick={handleGoBack}
          className="gap-2"
        >
          <ArrowLeft className="h-4 w-4" />
          Go Back
        </Button>
        <Button
          onClick={handleUploadNew}
        >
          Upload Another Invoice
        </Button>
      </div>
    </div>
  );
}
